module.exports = {
    USER_ROLES: ["ADMIN", "EDITOR", "VIEWER", "WORKER"],
    DEFAULT_ROLE: "WORKER"
}